import React from 'react';
import { BaseFieldProps } from './TextField';
import ProvenanceTooltip from '../layout/ProvenanceTooltip';
import LlmInstructionsTooltip from '../layout/LlmInstructionsTooltip';

const NumberField: React.FC<BaseFieldProps> = ({
  name,
  label,
  fieldName,
  llmInstructions,
  value,
  onChange,
  provenance,
  confidence,
  onProvenanceClick,
  error,
  required = false,
  disabled = false,
}) => {
  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 mb-1">
        <label
          htmlFor={name}
          className="block text-sm font-medium text-gray-700 truncate"
          title={label}
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
        {llmInstructions && <LlmInstructionsTooltip instructions={llmInstructions} />}
      </div>
      <div>
        <input
          type="number"
          id={name}
          name={name}
          value={value === null || value === undefined ? '' : value}
          onChange={(e) => {
            const raw = e.target.value;
            // Distingue chaîne vide (= null) de "0" (= 0). Number('') vaut 0,
            // donc on doit tester explicitement la chaîne vide AVANT de
            // convertir.
            if (raw === '') {
              onChange(name, null);
              return;
            }
            const n = Number(raw);
            onChange(name, Number.isNaN(n) ? null : n);
          }}
          disabled={disabled}
          className={`mt-1 block w-full rounded-md shadow-sm px-3 py-2 border ${
            error
              ? 'border-red-500 focus:border-red-500 focus:ring-red-500'
              : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500'
          } focus:outline-none focus:ring-1`}
        />
        <div className="flex items-center justify-end gap-2 mt-0.5">
          {fieldName && (
            <span
              className="text-[10px] text-gray-300 truncate"
              title={fieldName}
            >
              {fieldName}
            </span>
          )}
          <ProvenanceTooltip snippet={provenance?.snippet} page={provenance?.page} confidence={confidence} fieldLabel={label} onClick={onProvenanceClick} />
        </div>
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default NumberField;
